module.exports = __webpack_public_path__ + "img/161.4bd60bf3.png";